var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.landingPageData.useNewDesign
        ? [
            _c("order-now-bar"),
            _vm._v(" "),
            _c("order-widget-modern"),
            _vm._v(" "),
            _c("scroll-to-top-button", { staticClass: "d-block mx-auto" }),
            _vm._v(" "),
            _c("base-modpack"),
            _vm._v(" "),
            _c("landing-page-gallery"),
          ]
        : [_c("order-widget")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }